import { createContext } from 'react';

import { type LandlordOnboardingContextType } from 'src/pages/landlord/onboard/context/types';

// @ts-expect-error lazy init
export const LandlordOnboardingContext = createContext<LandlordOnboardingContextType>();
